/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import {
  displayMessage,
  postAPI,
  getAPI,
  formatDateTime,
} from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";

import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";

import {
  Space,
  Button,
  Card,
  Popconfirm,
  Layout,
  Table,
  Input,
  Drawer,
  Select,
  Tag,
} from "antd";

import { ALL_LEAD, DELETE_LEAD, EDIT_LEAD, STAFF } from "../../constants/api";

import LS_SERVICE from "../../utils/localStorage";
import { isBDE, isSuperAdmin, LEAD_STATUS } from "../../constants/constent";

import { Avatar, Row, Col, Typography, Descriptions } from "antd";
import { UserOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

function LeadTable() {
  const { Content } = Layout;
  const { Option } = Select;

  // Get the search (query params) from the URL
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type"); // Extract type from URL

  const [leads, setLeads] = useState([]);
  const [filteredLeads, setFilteredLeads] = useState([]);
  const [bdes, setBdes] = useState([]);
  const [selectedBDE, setSelectedBDE] = useState(null);

  const [loading, setLoading] = useState(false);

  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();

  const [viewLead, setViewLead] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const openDrawer = (lead) => {
    setViewLead(lead);
    setDrawerOpen(true);
  };

  // ------------------------------------
  // FETCH BDEs
  // ------------------------------------
  useLayoutEffect(() => {
    fetchBDEs();
  }, []);

  const fetchBDEs = () => {
    setLoading(true);
    getAPI(
      STAFF,
      (res) => {
        if (res.status) {
          setBdes(res.data.filter((u) => u.user_type === "bde"));
        }
        setLoading(false);
      },
      () => {
        displayMessage(ERROR_MSG_TYPE, "Unable to fetch BDEs");
        setLoading(false);
      },
    );
  };

  // ------------------------------------
  // GET LEADS (with filtering)
  // ------------------------------------
  useLayoutEffect(() => {
    getLeads();
  }, [selectedBDE]);

  const getLeads = () => {
    setLoading(true);

    // Build URL with filters
    let url = ALL_LEAD;

    if (isBDE()) {
      url = `${ALL_LEAD}?assigned_to=${LS_SERVICE.get("id")}`;
    } else if (selectedBDE) {
      url = `${ALL_LEAD}?assigned_to=${selectedBDE}`;
    }

    const payload = {};
    if (isBDE()) {
      payload.assigned_to = LS_SERVICE.get("id");
    } else if (selectedBDE) {
      payload.assigned_to = selectedBDE;
    }
    if (type) {
      payload.type = type;
    }

    postAPI(
      url,
      payload,
      (res) => {
        if (res.status) {
          const formatted = res.data.map((row, index) => ({
            key: index,
            sno: index + 1,
            ...row,
          }));
          setLeads(formatted);
          setFilteredLeads(formatted);
        } else {
          setLeads([]);
          setFilteredLeads([]);
        }
        setLoading(false);
      },
      () => {
        setLeads([]);
        setFilteredLeads([]);
        setLoading(false);
      },
    );
  };

  // ------------------------------------
  // SEARCH FUNCTION
  // ------------------------------------
  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = leads.filter((item) =>
      [
        item.hotel_name,
        item.contact_person,
        item.phone,
        item.area,
        item.property_type,
      ]
        .filter(Boolean)
        .some((field) => field.toLowerCase().includes(value.toLowerCase())),
    );

    setFilteredLeads(filtered);
  };

  // ------------------------------------
  // UPDATE STATUS
  // ------------------------------------
  const updateStatus = (row, val) => {
    setLoading(true);

    const jsonData = {
      id: row.id,
      hotel_name: row.hotel_name,
      contact_person: row.contact_person,
      phone: row.phone,
      area: row.area,
      status: val,
    };

    postAPI(
      EDIT_LEAD,
      jsonData,
      (res) => {
        displayMessage(
          res.status ? SUCCESS_MESSAGE : ERROR_MSG_TYPE,
          res.message,
        );
        getLeads();
      },
      () => {
        displayMessage(ERROR_MSG_TYPE, "Unable to update status");
        setLoading(false);
      },
    );
  };

  // ------------------------------------
  // DELETE LEAD
  // ------------------------------------
  const deleteData = (id) => {
    setLoading(true);

    postAPI(
      DELETE_LEAD,
      { id },
      (res) => {
        displayMessage(
          res.status ? SUCCESS_MESSAGE : ERROR_MSG_TYPE,
          res.message,
        );
        getLeads();
      },
      () => {
        displayMessage(ERROR_MSG_TYPE, "Unable to delete");
        setLoading(false);
      },
    );
  };

  // ------------------------------------
  // TABLE COLUMNS
  // ------------------------------------
  const columns = [
    { title: "S.No", dataIndex: "sno", width: 70 },

    { title: "Hotel", dataIndex: "hotel_name" },

    // { title: "Contact", dataIndex: "contact_person" },

    {
      title: "Phone",
      dataIndex: "phone",
      render: (phone) => (
        <a href={`tel:${phone}`} style={{ color: "#1677ff" }}>
          {phone}
        </a>
      ),
    },

    // { title: "Area", dataIndex: "area" },

    {
      title: "City",
      dataIndex: "city",
      render: (city) => city?.name ?? "-",
    },

    // {
    //   title: "State",
    //   dataIndex: "state",
    //   render: (state) => state?.name ?? "-",
    // },

    {
      title: "Assigned To",
      dataIndex: "assigned_to",
      render: (u) => <Tag color="blue">{u?.name ?? "Unassigned"}</Tag>,
    },

    {
      title: "Enquiry Source",
      dataIndex: "enquiry_source",
      render: (val) => <Tag color="green">{val}</Tag>,
    },

    {
      title: "Status",
      dataIndex: "status",
      render: (_, row) => (
        <Select
          style={{ width: "140px" }}
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
          defaultValue={row.status}
          onChange={(val) => updateStatus(row, val)}
          options={LEAD_STATUS}
        />
      ),
    },

    {
      title: "Created",
      dataIndex: "created_at",
      render: (date) => formatDateTime(date),
    },

    {
      title: "Actions",
      render: (_, row) => (
        <Space>
          {row.status === "converted" && (
            <Button
              onClick={() => navigate(`/vendor/on-boarding/${row.id}/lead`)}
            >
              OnBoard
            </Button>
          )}
          <Button onClick={() => openDrawer(row)}>View</Button>
          <Button onClick={() => navigate(`/lead/edit/${row.id}`)}>Edit</Button>
          {isSuperAdmin() && row.status !== "converted" && (
            <Popconfirm
              title="Are you sure to delete?"
              onConfirm={() => deleteData(row.id)}
            >
              <Button danger>Delete</Button>
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Manage Leads"
          extra={
            <Space>
              {/* BDE FILTER */}
              {isSuperAdmin() ? (
                <Select
                  style={{ width: 200 }}
                  placeholder="Filter by BDE"
                  allowClear
                  onChange={setSelectedBDE}
                >
                  <Option value={null}>All</Option>
                  {bdes.map((bde) => (
                    <Option key={bde.id} value={bde.id}>
                      {bde.name}
                    </Option>
                  ))}
                </Select>
              ) : null}

              {/* SEARCH */}
              <Input
                placeholder="Search…"
                value={searchText}
                onChange={(e) => handleSearch(e.target.value)}
                style={{ width: 260 }}
              />

              {/* RESET */}
              <Button onClick={getLeads}>
                <ReloadOutlined />
              </Button>

              {/* ADD LEAD */}
              <Button type="primary" onClick={() => navigate("/lead/add")}>
                <PlusOutlined /> Add Lead
              </Button>
            </Space>
          }
        >
          <Table
            loading={loading}
            columns={columns}
            dataSource={filteredLeads}
            pagination={{ pageSize: 10 }}
            scroll={{ x: 1200 }}
          />
        </Card>

        <Drawer
          title={
            viewLead?.hotel_name
              ? `${viewLead.hotel_name} - Details`
              : "Lead Details"
          }
          placement="right"
          width={720}
          onClose={() => setDrawerOpen(false)}
          open={drawerOpen}
          styles={{
            body: {
              background: "#f5f7fa",
              paddingBottom: 60,
            },
          }}
        >
          {viewLead ? (
            <Space direction="vertical" size="large" style={{ width: "100%" }}>
              {/* ================= BASIC INFORMATION ================= */}
              <Card title="Basic Information" bordered>
                <Descriptions
                  column={2}
                  size="middle"
                  labelStyle={{ fontWeight: 600 }}
                >
                  <Descriptions.Item label="Hotel Name">
                    {viewLead.hotel_name}
                  </Descriptions.Item>

                  <Descriptions.Item label="Property Type">
                    {viewLead.property_type ?? "-"}
                  </Descriptions.Item>

                  <Descriptions.Item label="Contact Person">
                    {viewLead.contact_person ?? "-"}
                  </Descriptions.Item>

                  <Descriptions.Item label="Phone">
                    {viewLead.phone ?? "-"}
                  </Descriptions.Item>

                  <Descriptions.Item label="Email">
                    {viewLead.email ?? "-"}
                  </Descriptions.Item>

                  <Descriptions.Item label="Status">
                    <Tag color="blue">{viewLead.status}</Tag>
                  </Descriptions.Item>

                  <Descriptions.Item label="Enquiry Source">
                    {viewLead.enquiry_source ?? "-"}
                  </Descriptions.Item>

                  <Descriptions.Item label="Next Follow-up">
                    {viewLead.next_followup_date ?? "-"}
                  </Descriptions.Item>

                  <Descriptions.Item label="Notes" span={2}>
                    {viewLead.notes ?? "-"}
                  </Descriptions.Item>
                </Descriptions>
              </Card>

              {/* ================= LOCATION ================= */}
              <Card title="Location" bordered>
                <Descriptions column={2} size="middle">
                  <Descriptions.Item label="Country">
                    {viewLead.country?.name ?? "-"}
                  </Descriptions.Item>

                  <Descriptions.Item label="State">
                    {viewLead.state?.name ?? "-"}
                  </Descriptions.Item>

                  <Descriptions.Item label="City">
                    {viewLead.city?.name ?? "-"}
                  </Descriptions.Item>

                  <Descriptions.Item label="Area">
                    {viewLead.area ?? "-"}
                  </Descriptions.Item>
                </Descriptions>
              </Card>

              {/* ================= ASSIGNED SALESPERSON ================= */}
              <Card title="Assigned Salesperson" bordered>
                <Row gutter={[16, 16]} align="middle">
                  <Col>
                    <Avatar size={64} icon={<UserOutlined />} />
                  </Col>

                  <Col flex="auto">
                    <Title level={5} style={{ marginBottom: 4 }}>
                      {viewLead.assigned_to?.name ?? "-"}
                    </Title>

                    <Text type="secondary">
                      {viewLead.assigned_to?.email ?? "-"}
                    </Text>

                    <br />

                    <Text type="secondary">
                      {viewLead.assigned_to?.phone ?? "-"}
                    </Text>

                    <br />

                    <Text type="secondary">
                      Employee Code:{" "}
                      {viewLead.assigned_to?.employee_code ?? "-"}
                    </Text>
                  </Col>
                </Row>
              </Card>

              {/* ================= SYSTEM INFORMATION ================= */}
              <Card title="System Information" bordered>
                <Descriptions column={2} size="small">
                  <Descriptions.Item label="Created At">
                    {viewLead.created_at ?? "-"}
                  </Descriptions.Item>

                  <Descriptions.Item label="Updated At">
                    {viewLead.updated_at ?? "-"}
                  </Descriptions.Item>

                  <Descriptions.Item label="Lead ID">
                    {viewLead.id ?? "-"}
                  </Descriptions.Item>
                </Descriptions>
              </Card>
            </Space>
          ) : (
            <Text type="secondary">No data available</Text>
          )}
        </Drawer>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default LeadTable;
